;(function(){

  /* UNBUILD */
  function USE(arg, req){
    return req? require(arg) : arg.slice? USE[R(arg)] : function(mod, path){
      arg(mod = {exports: {}});
      USE[R(path)] = mod.exports;
    }
    function R(p){
      return p.split('/').slice(-1).toString().replace('.js','');
    }
  }
  if(typeof module !== "undefined"){ var MODULE = module }
  /* UNBUILD */

  ;USE(function(module){
    // Security, Encryption, and Authorization: SEA.js
    // MANDATORY READING: https://gun.eco/explainers/data/security.html
    // IT IS IMPLEMENTED IN A POLYFILL/SHIM APPROACH.
    // THIS IS AN EARLY ALPHA!

    module.window = (typeof globalThis !== "undefined" && typeof window === "undefined" && typeof WorkerGlobalScope !== "undefined") ? globalThis : (typeof window !== "undefined" ? window : undefined);

    var tmp = module.window || module, u;
    var SEA = tmp.SEA || {};

    if(SEA.window = module.window){ SEA.window.SEA = SEA }

    try{ if(u+'' !== typeof MODULE){ MODULE.exports = SEA } }catch(e){}
    module.exports = SEA;
  })(USE, './root');

  ;USE(function(module){
    var SEA = USE('./root');
    try{ if(SEA.window){
      if(location.protocol.indexOf('s') < 0
      && location.host.indexOf('localhost') < 0
      && ! /^127\.\d+\.\d+\.\d+$/.test(location.hostname)
      && location.protocol.indexOf('blob:') < 0
      && location.protocol.indexOf('file:') < 0
      && location.origin != 'null'){
        console.warn('HTTPS needed for WebCrypto in SEA, redirecting...');
        location.protocol = 'https:'; // WebCrypto does NOT work without HTTPS!
      }
    } }catch(e){}
  })(USE, './https');

  ;USE(function(module){
    var u, root = (typeof globalThis !== "undefined") ? globalThis : (typeof global !== "undefined" ? global : (typeof window !== "undefined" ? window : this));
    var native = {}
    native.btoa = (u+'' != typeof root.btoa) && root.btoa;
    native.atob = (u+'' != typeof root.atob) && root.atob;
    if(u+'' == typeof Buffer){
      if(u+'' != typeof require){
        try{ root.Buffer = USE("buffer", 1).Buffer }catch(e){ console.log("Please `npm install buffer` or add it to your package.json !") }
      }
    }
    if(u+'' != typeof Buffer){
      root.btoa = function(data){ return Buffer.from(data, "binary").toString("base64").replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');};
      root.atob = function(data){
        var tmp = data.replace(/-/g, '+').replace(/_/g, '/')
        while(tmp.length % 4){ tmp += '=' }
        return Buffer.from(tmp, "base64").toString("binary");
      };
      return;
    }
    if(native.btoa){
      root.btoa = function(data){ return native.btoa(data).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, ''); };
    }
    if(native.atob){
      root.atob = function(data){
        var tmp = data.replace(/-/g, '+').replace(/_/g, '/')
        while(tmp.length % 4){ tmp += '=' }
        return native.atob(tmp);
      };
    }
  })(USE, './base64');

  ;USE(function(module){
    USE('./base64');
    // This is Array extended to have .toString(['utf8'|'hex'|'base64'])
    function SeaArray() {}
    Object.assign(SeaArray, { from: Array.from })
    SeaArray.prototype = Object.create(Array.prototype)
    SeaArray.prototype.toString = function(enc, start, end) { enc = enc || 'utf8'; start = start || 0;
      const length = this.length
      if (enc === 'hex') {
        const buf = new Uint8Array(this)
        return [ ...Array(((end && (end + 1)) || length) - start).keys()]
        .map((i) => buf[ i + start ].toString(16).padStart(2, '0')).join('')
      }
      if (enc === 'utf8') {
        return Array.from(
          { length: (end || length) - start },
          (_, i) => String.fromCharCode(this[ i + start])
        ).join('')
      }
      if (enc === 'base64') {
        return btoa(this)
      }
    }
    module.exports = SeaArray;
  })(USE, './array');

  ;USE(function(module){
    USE('./base64');
    // This is Buffer implementation used in SEA. Functionality is mostly
    // compatible with NodeJS 'safe-buffer' and is used for encoding conversions
    // between binary and 'hex' | 'utf8' | 'base64'
    // See documentation and validation for safe implementation in:
    // https://github.com/feross/safe-buffer#update
    var SeaArray = USE('./array');
    function SafeBuffer(...props) {
      console.warn('new SafeBuffer() is depreciated, please use SafeBuffer.from()')
      return SafeBuffer.from(...props)
    }
    SafeBuffer.prototype = Object.create(Array.prototype)
    Object.assign(SafeBuffer, {
      // (data, enc) where typeof data === 'string' then enc === 'utf8'|'hex'|'base64'
      from() {
        if (!Object.keys(arguments).length || arguments[0]==null) {
          throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
        }
        const input = arguments[0]
        let buf
        if (typeof input === 'string') {
          const enc = arguments[1] || 'utf8'
          if (enc === 'hex') {
            const bytes = input.match(/([\da-fA-F]{2})/g)
            .map((byte) => parseInt(byte, 16))
            if (!bytes || !bytes.length) {
              throw new TypeError('Invalid first argument for type \'hex\'.')
            }
            buf = SeaArray.from(bytes)
          } else if (enc === 'utf8' || 'binary' === enc) { // EDIT BY MARK: I think this is safe, tested it against a couple "binary" strings. This lets SafeBuffer match NodeJS Buffer behavior more where it safely btoas regular strings.
            const length = input.length
            const words = new Uint16Array(length)
            Array.from({ length: length }, (_, i) => words[i] = input.charCodeAt(i))
            buf = SeaArray.from(words)
          } else if (enc === 'base64') {
            const dec = atob(input)
            const length = dec.length
            const bytes = new Uint8Array(length)
            Array.from({ length: length }, (_, i) => bytes[i] = dec.charCodeAt(i))
            buf = SeaArray.from(bytes)
          } else if (enc === 'binary') { // deprecated by above comment
            buf = SeaArray.from(input) // some btoas were mishandled.
          } else {
            console.info('SafeBuffer.from unknown encoding: '+enc)
          }
          return buf
        }
        const byteLength = input.byteLength // what is going on here? FOR MARTTI
        const length = input.byteLength ? input.byteLength : input.length
        if (length) {
          let buf
          if (input instanceof ArrayBuffer) {
            buf = new Uint8Array(input)
          }
          return SeaArray.from(buf || input)
        }
      },
      // This is 'safe-buffer.alloc' sans encoding support
      alloc(length, fill = 0 /*, enc*/ ) {
        return SeaArray.from(new Uint8Array(Array.from({ length: length }, () => fill)))
      },
      // This is normal UNSAFE 'buffer.alloc' or 'new Buffer(length)' - don't use!
      allocUnsafe(length) {
        return SeaArray.from(new Uint8Array(Array.from({ length : length })))
      },
      // This puts together array of array like members
      concat(arr) { // octet array
        if (!Array.isArray(arr)) {
          throw new TypeError('First argument must be Array containing ArrayBuffer or Uint8Array instances.')
        }
        return SeaArray.from(arr.reduce((ret, item) => ret.concat(Array.from(item)), []))
      }
    })
    SafeBuffer.prototype.from = SafeBuffer.from
    SafeBuffer.prototype.toString = SeaArray.prototype.toString

    module.exports = SafeBuffer;
  })(USE, './buffer');

  ;USE(function(module){
    const SEA = USE('./root')
    const api = {Buffer: USE('./buffer')}
    var o = {}, u;

    // ideally we can move away from JSON entirely? unlikely due to compatibility issues... oh well.
    JSON.parseAsync = JSON.parseAsync || function(t,cb,r){ var u; try{ cb(u, JSON.parse(t,r)) }catch(e){ cb(e) } }
    JSON.stringifyAsync = JSON.stringifyAsync || function(v,cb,r,s){ var u; try{ cb(u, JSON.stringify(v,r,s)) }catch(e){ cb(e) } }

    api.parse = function(t,r){ return new Promise(function(res, rej){
      JSON.parseAsync(t,function(err, raw){ err? rej(err) : res(raw) },r);
    })}
    api.stringify = function(v,r,s){ return new Promise(function(res, rej){
      JSON.stringifyAsync(v,function(err, raw){ err? rej(err) : res(raw) },r,s);
    })}

    if(SEA.window){
      api.crypto = SEA.window.crypto || SEA.window.msCrypto
      api.subtle = (api.crypto||o).subtle || (api.crypto||o).webkitSubtle;
      api.TextEncoder = SEA.window.TextEncoder;
      api.TextDecoder = SEA.window.TextDecoder;
      api.random = (len) => api.Buffer.from(api.crypto.getRandomValues(new Uint8Array(api.Buffer.alloc(len))));
    }
    if(!api.TextDecoder)
    {
      const { TextEncoder, TextDecoder } = USE((u+'' == typeof MODULE?'.':'')+'./lib/text-encoding', 1);
      api.TextDecoder = TextDecoder;
      api.TextEncoder = TextEncoder;
    }
    if(!api.crypto)
    {
      try
      {
      var crypto = USE('crypto', 1);
      Object.assign(api, {
        crypto,
        random: (len) => api.Buffer.from(crypto.randomBytes(len))
      });      
      const { Crypto: WebCrypto } = USE('@peculiar/webcrypto', 1);
      api.ossl = api.subtle = new WebCrypto({directory: 'ossl'}).subtle // ECDH
    }
    catch(e){
      console.log("Please `npm install @peculiar/webcrypto` or add it to your package.json !");
    }}

    module.exports = api
  })(USE, './shim');

  ;USE(function(module){
    var SEA = USE('./root');
    var shim = USE('./shim');

    // Base62 alphabet: digits → uppercase → lowercase (62 chars, a-zA-Z0-9 only)
    var ALPHA = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    var ALPHA_MAP = {};
    for (var i = 0; i < ALPHA.length; i++) { ALPHA_MAP[ALPHA[i]] = i; }

    // Fixed output length for a 256-bit (32-byte) value in base62
    // 62^44 > 2^256 ✓
    var PUB_LEN = 44;

    // BigInt → base62 string, zero-padded to PUB_LEN (44 chars)
    function biToB62(n) {
        if (typeof n !== 'bigint' || n < 0n) {
            throw new Error('biToB62: input must be non-negative BigInt');
        }
        var s = '';
        var v = n;
        while (v > 0n) {
            s = ALPHA[Number(v % 62n)] + s;
            v = v / 62n;
        }
        while (s.length < PUB_LEN) { s = '0' + s; }
        if (s.length > PUB_LEN) {
            throw new Error('biToB62: value too large for ' + PUB_LEN + '-char base62');
        }
        return s;
    }

    // base62 string → BigInt (accepts exactly PUB_LEN chars)
    function b62ToBI(s) {
        if (typeof s !== 'string' || s.length !== PUB_LEN) {
            throw new Error('b62ToBI: expected ' + PUB_LEN + '-char base62 string, got ' + (s && s.length));
        }
        if (!/^[A-Za-z0-9]+$/.test(s)) {
            throw new Error('b62ToBI: invalid base62 characters');
        }
        var n = 0n;
        for (var i = 0; i < s.length; i++) {
            var c = ALPHA_MAP[s[i]];
            if (c === undefined) { throw new Error('b62ToBI: unknown char ' + s[i]); }
            n = n * 62n + BigInt(c);
        }
        return n;
    }

    // base64url string (43 chars, from JWK) → base62 (44 chars)
    function b64ToB62(s) {
        if (typeof s !== 'string' || !s) {
            throw new Error('b64ToB62: input must be non-empty string');
        }
        var hex = shim.Buffer.from(atob(s), 'binary').toString('hex');
        var n = BigInt('0x' + (hex || '0'));
        return biToB62(n);
    }

    // base62 (44 chars) → base64url string (for JWK)
    function b62ToB64(s) {
        var n = b62ToBI(s);
        var hex = n.toString(16).padStart(64, '0');
        var b64 = shim.Buffer.from(hex, 'hex').toString('base64')
            .replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
        return b64;
    }

    // Parse pub (old or new format) → { x, y } as base64url strings (for JWK importKey)
    // Old format: [43 base64url].[43 base64url]  length=87
    // New format: [44 base62][44 base62]          length=88
    function pubToJwkXY(pub) {
        if (typeof pub !== 'string') {
            throw new Error('pubToJwkXY: pub must be a string');
        }
        if (pub.length === 87 && pub[43] === '.') {
            // Old base64url format
            var parts = pub.split('.');
            if (parts.length !== 2) { throw new Error('pubToJwkXY: invalid old pub format'); }
            return { x: parts[0], y: parts[1] };
        }
        if (pub.length === 88 && /^[A-Za-z0-9]{88}$/.test(pub)) {
            // New base62 format
            return {
                x: b62ToB64(pub.slice(0, 44)),
                y: b62ToB64(pub.slice(44))
            };
        }
        throw new Error('pubToJwkXY: unrecognised pub format (length=' + pub.length + ')');
    }

    // Encode arbitrary Buffer/Uint8Array as base62: chunks into 32-byte blocks, each → 44 chars
    // e.g. SHA-256 (32B) → 44 chars, PBKDF2 (64B) → 88 chars
    function bufToB62(buf) {
        var out = '';
        for (var i = 0; i < buf.length; i += 32) {
            var end = Math.min(i + 32, buf.length);
            var hex = '';
            // left-pad short last chunk to 32 bytes
            for (var p = 0; p < 32 - (end - i); p++) { hex += '00'; }
            for (var j = i; j < end; j++) {
                hex += ('0' + buf[j].toString(16)).slice(-2);
            }
            out += biToB62(BigInt('0x' + hex));
        }
        return out;
    }

    var b62 = { biToB62: biToB62, b62ToBI: b62ToBI, b64ToB62: b64ToB62, b62ToB64: b62ToB64, pubToJwkXY: pubToJwkXY, bufToB62: bufToB62, PUB_LEN: PUB_LEN };
    SEA.base62 = b62;
    module.exports = b62;
  })(USE, './base62');

  ;USE(function(module){
    var SEA = USE('./root');
    var shim = USE('./shim');
    var b62 = SEA.base62;
    var s = {};
    s.pbkdf2 = {hash: {name : 'SHA-256'}, iter: 100000, ks: 64};
    s.ecdsa = {
      pair: {name: 'ECDSA', namedCurve: 'P-256'},
      sign: {name: 'ECDSA', hash: {name: 'SHA-256'}}
    };
    s.ecdh = {name: 'ECDH', namedCurve: 'P-256'};

    // This creates Web Cryptography API compliant JWK for sign/verify purposes
    s.jwk = function(pub, d){  // d === priv
      var xy = b62.pubToJwkXY(pub); // handles old (87-char x.y) and new (88-char base62)
      var x = xy.x, y = xy.y;
      var jwk = {kty: "EC", crv: "P-256", x: x, y: y, ext: true};
      jwk.key_ops = d ? ['sign'] : ['verify'];
      // Convert base62 priv (44-char) back to base64url for WebCrypto JWK importKey
      if(d){ jwk.d = (d.length === 44 && /^[A-Za-z0-9]{44}$/.test(d)) ? b62.b62ToB64(d) : d }
      return jwk;
    };

    s.keyToJwk = function(keyBytes) {
      const keyB64 = keyBytes.toString('base64');
      const k = keyB64.replace(/\+/g, '-').replace(/\//g, '_').replace(/\=/g, '');
      return { kty: 'oct', k: k, ext: false, alg: 'A256GCM' };
    }

    s.recall = {
      validity: 12 * 60 * 60, // internally in seconds : 12 hours
      hook: function(props){ return props } // { iat, exp, alias, remember } // or return new Promise((resolve, reject) => resolve(props)
    };

    s.check = function(t){ return (typeof t == 'string') && ('SEA{' === t.slice(0,4)) }
    s.parse = async function p(t){ try {
      var yes = (typeof t == 'string');
      if(yes && 'SEA{' === t.slice(0,4)){ t = t.slice(3) }
      return yes ? await shim.parse(t) : t;
      } catch (e) {}
      return t;
    }

    SEA.opt = s;
    module.exports = s
  })(USE, './settings');

  ;USE(function(module){
    var shim = USE('./shim');
    module.exports = async function(d, o){
      var t = (typeof d == 'string')? d : await shim.stringify(d);
      var hash = await shim.subtle.digest({name: o||'SHA-256'}, new shim.TextEncoder().encode(t));
      return shim.Buffer.from(hash);
    }
  })(USE, './sha256');

  ;USE(function(module){
    // This internal func returns SHA-1 hashed data for KeyID generation
    const __shim = USE('./shim')
    const subtle = __shim.subtle
    const ossl = __shim.ossl ? __shim.ossl : subtle
    const sha1hash = (b) => ossl.digest({name: 'SHA-1'}, new ArrayBuffer(b))
    module.exports = sha1hash
  })(USE, './sha1');

  ;USE(function(module){
    var SEA = USE('./root');
    var shim = USE('./shim');
    var S = USE('./settings');
    var sha = USE('./sha256');
    var u;

    SEA.work = SEA.work || (async (data, pair, cb, opt) => { try { // used to be named `proof`
      var salt = (pair||{}).epub || pair; // epub not recommended, salt should be random!
      opt = opt || {};
      var enc = opt.encode || 'base62';
      var b62 = SEA.base62;
      if(salt instanceof Function){
        cb = salt;
        salt = u;
      }
      // Check if data is an ArrayBuffer, if so use Uint8Array to access the data
      if(data instanceof ArrayBuffer){
        data = new Uint8Array(data);
        data = new shim.TextDecoder("utf-8").decode(data);
      }
      data = (typeof data == 'string') ? data : await shim.stringify(data);
      if('sha' === (opt.name||'').toLowerCase().slice(0,3)){
        var rsha = shim.Buffer.from(await sha(data, opt.name), 'binary');
        rsha = ('base62' === enc) ? b62.bufToB62(rsha) : ('base64' === enc) ? btoa(String.fromCharCode(...new Uint8Array(rsha))) : rsha.toString(enc);
        if(cb){ try{ cb(rsha) }catch(e){console.log(e)} }
        return rsha;
      }
      if (typeof salt === "number") salt = salt.toString();
      if (typeof opt.salt === "number") opt.salt = opt.salt.toString();
      salt = salt || shim.random(9);
      var key = await (shim.ossl || shim.subtle).importKey('raw', new shim.TextEncoder().encode(data), {name: opt.name || 'PBKDF2'}, false, ['deriveBits']);
      var work = await (shim.ossl || shim.subtle).deriveBits({
        name: opt.name || 'PBKDF2',
        iterations: opt.iterations || S.pbkdf2.iter,
        salt: new shim.TextEncoder().encode(opt.salt || salt),
        hash: opt.hash || S.pbkdf2.hash,
      }, key, opt.length || (S.pbkdf2.ks * 8))
      data = shim.random(data.length)  // Erase data in case of passphrase
      var r = shim.Buffer.from(work, 'binary');
      r = ('base62' === enc) ? b62.bufToB62(r) : ('base64' === enc) ? btoa(String.fromCharCode(...new Uint8Array(r))) : r.toString(enc);
      if(cb){ try{ cb(r) }catch(e){console.log(e)} }
      return r;
    } catch(e) { 
      console.log(e);
      SEA.err = e;
      if(SEA.throw){ throw e }
      if(cb){ cb() }
      return;
    }});

    module.exports = SEA.work;
  })(USE, './work');

  ;USE(function(module){
    var SEA = USE('./root');
    var shim = USE('./shim');
    var b62 = SEA.base62;

    // P-256 curve constants
    const n = BigInt("0xffffffff00000000ffffffffffffffffbce6faada7179e84f3b9cac2fc632551");
    const P = BigInt("0xffffffff00000001000000000000000000000000ffffffffffffffffffffffff");
    const A = BigInt("0xffffffff00000001000000000000000000000000fffffffffffffffffffffffc");
    const B = BigInt("0x5ac635d8aa3a93e7b3ebbd55769886bc651d06b0cc53b0f63bce3c3e27d2604b"); // Curve coefficient b
    const G = {
      x: BigInt("0x6b17d1f2e12c4247f8bce6e563a440f277037d812deb33a0f4a13945d898c296"),
      y: BigInt("0x4fe342e2fe1a7f9b8ee7eb4a7c0f9e162bce33576b315ececbb6406837bf51f5")
    };

    // Core ECC functions
    function mod(a, m) { return ((a % m) + m) % m; }

    // Modular inverse using Fermat's Little Theorem (p is prime)
    // WARNING: modPow must be constant-time to prevent timing attacks on secret keys
    function modInv(a, p) {
        // a^(p-2) mod p
        return modPow(a, p - BigInt(2), p);
    }

    // Constant-time modular exponentiation using binary exponentiation
    // Always performs all iterations to prevent timing attacks
    // Uses conditional assignment instead of branches
    function modPow(base, exponent, modulus) {
        if (modulus === BigInt(1)) return BigInt(0);
        base = mod(base, modulus);
        let result = BigInt(1);
        let exp = exponent;

        // Process all bits with constant execution time
        while (exp > BigInt(0)) {
            const bit = exp & BigInt(1);
            // Always perform multiplication
            const temp = mod(result * base, modulus);
            // Constant-time conditional assignment (no branch prediction leak)
            result = bit ? temp : result;
            exp >>= BigInt(1);
            base = mod(base * base, modulus);
        }
        return result;
    }

    // Verify a point is on the curve
    function isOnCurve(point) {
        if (!point) return false;
        // y² = x³ + ax + b (mod p)
        const { x, y } = point;
        const left = mod(y * y, P);
        const right = mod(mod(mod(x * x, P) * x, P) + mod(A * x, P) + B, P);
        return left === right;
    }

    function pointAdd(p1, p2) {
      if (p1 === null) return p2; if (p2 === null) return p1;
      if (p1.x === p2.x && mod(p1.y + p2.y, P) === 0n) return null;
      let lambda = p1.x === p2.x && p1.y === p2.y
        ? mod((3n * mod(p1.x ** 2n, P) + A) * modInv(2n * p1.y, P), P)
        : mod((mod(p2.y - p1.y, P)) * modInv(mod(p2.x - p1.x, P), P), P);
      const x3 = mod(lambda ** 2n - p1.x - p2.x, P);
      return { x: x3, y: mod(lambda * mod(p1.x - x3, P) - p1.y, P) };
    }

    function pointMult(k, point) {
      // Fixed-window scalar multiplication to reduce timing variance
      let r = null, a = point;
      for (let i = 0; i < 256; i++) {
        const bit = (k >> BigInt(i)) & 1n;
        const temp = pointAdd(r, a);
        r = bit ? temp : r;
        a = pointAdd(a, a);
      }
      return r;
    }

    SEA.pair = SEA.pair || (async (cb, opt) => { try {
      opt = opt || {};
      const subtle = shim.subtle, ecdhSubtle = shim.ossl || subtle;
      let r = {};

      // Helper functions
      const b64ToBI = s => {
        // Validate base64 input format
        if (typeof s !== 'string' || s.length === 0) {
          throw new Error("Invalid base64 input: must be non-empty string");
        }
        // Standard base64url validation
        if (!/^[A-Za-z0-9_-]*={0,2}$/.test(s)) {
          throw new Error("Invalid base64 characters detected");
        }

        try {
          const hex = shim.Buffer.from(atob(s), 'binary').toString('hex');

          // Validate result is within P-256 range (256 bits / 64 hex chars)
          if (hex.length > 64) {
            throw new Error("Decoded value exceeds 256 bits for P-256");
          }

          const value = BigInt('0x' + hex);
          return value;
        } catch (e) {
          if (e.message.includes("256 bits")) throw e;
          throw new Error("Invalid base64 decoding: " + e.message);
        }
      };
      // privToBI: parse priv/epriv accepting both old 43-char base64url and new 44-char base62
      const privToBI = s => {
        if (typeof s === 'string' && s.length === 44 && /^[A-Za-z0-9]{44}$/.test(s)) {
          return b62.b62ToBI(s);
        }
        return b64ToBI(s); // backward compat: old base64url 43-char
      };
      const biToB64 = n => {
        // Validate input is within valid range for P-256 (256 bits max)
        const max256bit = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
        if (n < 0n || n > max256bit) {
          throw new Error("Invalid BigInt: must be 0 <= n <= 2^256-1");
        }
        const hex = n.toString(16).padStart(64, '0');
        if (hex.length > 64) {
          throw new Error("BigInt too large for P-256: exceeds 256 bits");
        }
        const b64 = shim.Buffer.from(hex, 'hex').toString('base64')
          .replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
        return b64;
      };
      const ensurePrivRange = (priv, name) => {
        if (priv <= 0n || priv >= n) {
          throw new Error((name || 'Private key') + " out of range");
        }
        return priv;
      };
      const pubFromPriv = priv => {
        ensurePrivRange(priv, 'Private key');
        const pub = pointMult(priv, G);
        if (!isOnCurve(pub)) throw new Error("Invalid point generated");
        return b62.biToB62(pub.x) + b62.biToB62(pub.y);
      };
      const parsePub = pubStr => {
        if (!pubStr || typeof pubStr !== 'string') {
          throw new Error("Invalid pub format: must be string");
        }
        const xy = b62.pubToJwkXY(pubStr); // handles both old (87) and new (88) format
        const point = { x: b64ToBI(xy.x), y: b64ToBI(xy.y) };
        if (point.x >= P || point.y >= P) {
          throw new Error("Invalid public key: out of range");
        }
        if (!isOnCurve(point)) {
          throw new Error("Invalid public key: not on curve");
        }
        return point;
      };
      const pointToPub = point => {
        if (!point || !isOnCurve(point)) {
          throw new Error("Invalid point: not on curve");
        }
        return b62.biToB62(point.x) + b62.biToB62(point.y);
      };
      const seedToBuffer = seed => {
        const enc = new shim.TextEncoder();
        if (typeof seed === 'string') {
          return enc.encode(seed).buffer;
        }
        if (seed instanceof ArrayBuffer) {
          return seed;
        }
        if (seed && seed.byteLength !== undefined) {
          return seed.buffer || seed;
        }
        return null;
      };
      const seedToKey = async (seed, salt) => {
        const enc = new shim.TextEncoder();
        const buf = seedToBuffer(seed);
        if (!buf) throw new Error("Invalid seed");
        const combined = new Uint8Array(buf.byteLength + enc.encode(salt).buffer.byteLength);
        combined.set(new Uint8Array(buf), 0);
        combined.set(new Uint8Array(enc.encode(salt).buffer), buf.byteLength);
        const hash = await subtle.digest("SHA-256", combined.buffer);

        // Use rejected resampling for uniform distribution
        // Keep hashing until we get a valid private key in range [1, n)
        let hashData = hash;
        let attemptCount = 0;
        const maxAttempts = 100; // Prevent infinite loops

        while (attemptCount < maxAttempts) {
          let priv = BigInt("0x" + Array.from(new Uint8Array(hashData))
            .map(b => b.toString(16).padStart(2, "0")).join(""));

          // Check if priv is in valid range [1, n)
          if (priv > 0n && priv < n) {
            return priv;
          }

          // Resample by hashing the previous result with counter
          const counterBuf = new Uint8Array(4);
          new DataView(counterBuf.buffer).setUint32(0, attemptCount, true);
          const combined2 = new Uint8Array(hashData.byteLength + counterBuf.byteLength);
          combined2.set(new Uint8Array(hashData), 0);
          combined2.set(counterBuf, hashData.byteLength);
          hashData = await subtle.digest("SHA-256", combined2.buffer);
          attemptCount++;
        }

        throw new Error("Failed to generate valid private key after " + maxAttempts + " attempts");
      };
      const hashToScalar = async (seed, label, counter) => {
        const enc = new shim.TextEncoder();
        const buf = seedToBuffer(seed);
        if (!buf) throw new Error("Invalid seed");
        const labelStr = counter !== undefined && counter !== null ? label + counter : label;
        const labelBuf = enc.encode(labelStr).buffer;
        const combined = new Uint8Array(buf.byteLength + labelBuf.byteLength);
        combined.set(new Uint8Array(labelBuf), 0);
        combined.set(new Uint8Array(buf), labelBuf.byteLength);
        const hash = await subtle.digest("SHA-256", combined.buffer);

        let hashData = hash;
        let attemptCount = 0;
        const maxAttempts = 100;
        while (attemptCount < maxAttempts) {
          const scalar = BigInt("0x" + Array.from(new Uint8Array(hashData))
            .map(b => b.toString(16).padStart(2, "0")).join(""));
          if (scalar > 0n && scalar < n) {
            return scalar;
          }
          const counterBuf = new Uint8Array(4);
          new DataView(counterBuf.buffer).setUint32(0, attemptCount, true);
          const combined2 = new Uint8Array(hashData.byteLength + counterBuf.byteLength);
          combined2.set(new Uint8Array(hashData), 0);
          combined2.set(counterBuf, hashData.byteLength);
          hashData = await subtle.digest("SHA-256", combined2.buffer);
          attemptCount++;
        }
        throw new Error("Failed to derive scalar after " + maxAttempts + " attempts");
      };

      const deriveScalar = async (seed, label, attempt) => {
        return hashToScalar(seed, label, attempt === 0 ? null : attempt);
      };
      const derivePrivWithRetry = async (priv, label) => {
        for (let attempt = 0; attempt < 100; attempt++) {
          const offset = await deriveScalar(opt.seed, label, attempt);
          const derivedPriv = mod(priv + offset, n);
          if (derivedPriv !== 0n) {
            return { derivedPriv, attempt };
          }
        }
        throw new Error("Failed to derive non-zero private key");
      };
      const derivePubWithRetry = async (pubPoint, label) => {
        for (let attempt = 0; attempt < 100; attempt++) {
          const offset = await deriveScalar(opt.seed, label, attempt);
          const derivedPub = pointAdd(pubPoint, pointMult(offset, G));
          if (derivedPub) {
            return derivedPub;
          }
        }
        throw new Error("Failed to derive valid public key");
      };

      if (opt.seed && (opt.priv || opt.epriv || opt.pub || opt.epub)) {
        r = {};
        if (opt.priv) {
          const priv = ensurePrivRange(privToBI(opt.priv), 'Private key');
          const signResult = await derivePrivWithRetry(priv, "SEA.DERIVE|sign|");
          const derivedPriv = signResult.derivedPriv;
          const derivedPub = pointMult(derivedPriv, G);
          r.priv = b62.biToB62(derivedPriv);
          r.pub = pointToPub(derivedPub);
        }
        if (opt.epriv) {
          const epriv = ensurePrivRange(privToBI(opt.epriv), 'Encryption private key');
          const encResult = await derivePrivWithRetry(epriv, "SEA.DERIVE|encrypt|");
          const derivedEpriv = encResult.derivedPriv;
          const derivedEpub = pointMult(derivedEpriv, G);
          r.epriv = b62.biToB62(derivedEpriv);
          r.epub = pointToPub(derivedEpub);
        }
        if (opt.pub) {
          const pubPoint = parsePub(opt.pub);
          const derivedPub = await derivePubWithRetry(pubPoint, "SEA.DERIVE|sign|");
          r.pub = pointToPub(derivedPub);
        }
        if (opt.epub) {
          const epubPoint = parsePub(opt.epub);
          const derivedEpub = await derivePubWithRetry(epubPoint, "SEA.DERIVE|encrypt|");
          r.epub = pointToPub(derivedEpub);
        }
      } else if (opt.priv) {
        const priv = ensurePrivRange(privToBI(opt.priv), 'Private key');
        r = { priv: opt.priv, pub: pubFromPriv(priv) };
        if (opt.epriv) {
          const epriv = ensurePrivRange(privToBI(opt.epriv), 'Encryption private key');
          r.epriv = opt.epriv;
          r.epub = pubFromPriv(epriv);
        } else {
          try {
            const dh = await ecdhSubtle.generateKey({name: 'ECDH', namedCurve: 'P-256'}, true, ['deriveKey'])
            .then(async k => ({ 
              epriv: b62.b64ToB62((await ecdhSubtle.exportKey('jwk', k.privateKey)).d),
              epub: b62.b64ToB62((await ecdhSubtle.exportKey('jwk', k.publicKey)).x) +
                    b62.b64ToB62((await ecdhSubtle.exportKey('jwk', k.publicKey)).y)
            }));
            r.epriv = dh.epriv; r.epub = dh.epub;
          } catch(e) {}
        }
      } else if (opt.epriv) {
        const epriv = ensurePrivRange(privToBI(opt.epriv), 'Encryption private key');
        r = { epriv: opt.epriv, epub: pubFromPriv(epriv) };
        if (opt.priv) {
          const priv = ensurePrivRange(privToBI(opt.priv), 'Private key');
          r.priv = opt.priv;
          r.pub = pubFromPriv(priv);
        } else {
          const sa = await subtle.generateKey({name: 'ECDSA', namedCurve: 'P-256'}, true, ['sign', 'verify'])
          .then(async k => ({ 
            priv: b62.b64ToB62((await subtle.exportKey('jwk', k.privateKey)).d),
            pub: b62.b64ToB62((await subtle.exportKey('jwk', k.publicKey)).x) +
                 b62.b64ToB62((await subtle.exportKey('jwk', k.publicKey)).y)
          }));
          r.priv = sa.priv; r.pub = sa.pub;
        }
      } else if (opt.seed) {
        const signPriv = await seedToKey(opt.seed, "-sign");
        const encPriv = await seedToKey(opt.seed, "-encrypt");
        r = {
          priv: b62.biToB62(signPriv), pub: pubFromPriv(signPriv),
          epriv: b62.biToB62(encPriv), epub: pubFromPriv(encPriv)
        };
      } else {
        const sa = await subtle.generateKey({name: 'ECDSA', namedCurve: 'P-256'}, true, ['sign', 'verify'])
        .then(async k => ({ 
          priv: b62.b64ToB62((await subtle.exportKey('jwk', k.privateKey)).d),
          pub: b62.b64ToB62((await subtle.exportKey('jwk', k.publicKey)).x) +
               b62.b64ToB62((await subtle.exportKey('jwk', k.publicKey)).y)
        }));
        r = { pub: sa.pub, priv: sa.priv };
        try {
          const dh = await ecdhSubtle.generateKey({name: 'ECDH', namedCurve: 'P-256'}, true, ['deriveKey'])
          .then(async k => ({ 
            epriv: b62.b64ToB62((await ecdhSubtle.exportKey('jwk', k.privateKey)).d),
            epub: b62.b64ToB62((await ecdhSubtle.exportKey('jwk', k.publicKey)).x) +
                  b62.b64ToB62((await ecdhSubtle.exportKey('jwk', k.publicKey)).y)
          }));
          r.epub = dh.epub; r.epriv = dh.epriv;
        } catch(e) {}
      }

      if(cb) try{ cb(r) }catch(e){ /* Silently ignore callback errors to prevent leaking secrets */ }
      return r;
    } catch(e) {
      SEA.err = e;
      if(SEA.throw) throw e;
      if(cb) try { cb(); } catch(cbErr) { /* Ignore callback errors */ }
      throw new Error("Key generation failed: " + (e.message || "Unknown error"));
    }});

    module.exports = SEA.pair;
  })(USE, './pair');

  ;USE(function(module){
    var SEA = USE('./root');
    var shim = USE('./shim');
    var S = USE('./settings');
    var sha = USE('./sha256');
    var u;

    async function n(r, o, c) {
      try {
        if(!o.raw){ r = 'SEA' + await shim.stringify(r) }
        if(c){ try{ c(r) }catch(e){} }
        return r;
      } catch(e) { return r }
    }

    async function w(r, j, o, c) {
      var x = {
        m: j,
        s: r.signature ? shim.Buffer.from(r.signature, 'binary').toString(o.encode || 'base64') : u,
        a: shim.Buffer.from(r.authenticatorData, 'binary').toString('base64'),
        c: shim.Buffer.from(r.clientDataJSON, 'binary').toString('base64')
      };
      if (!x.s || !x.a || !x.c) throw "WebAuthn signature invalid";
      return n(x, o, c);
    }

    async function k(p, j, o, c) {
      var x = S.jwk(p.pub, p.priv);
      if (!x) throw "Invalid key pair";
      var h = await sha(j);
      var s = await (shim.ossl || shim.subtle).importKey('jwk', x, S.ecdsa.pair, false, ['sign'])
      .then((k) => (shim.ossl || shim.subtle).sign(S.ecdsa.sign, k, new Uint8Array(h)))
      .catch(() => { throw "SEA signature failed" });
      return n({m: j, s: shim.Buffer.from(s, 'binary').toString(o.encode || 'base64')}, o, c);
    }

    SEA.sign = SEA.sign || (async (data, pair, cb, opt) => { try {
      opt = opt || {};
      if(u === data) throw '`undefined` not allowed.';
      if(!(pair||opt).priv && typeof pair !== 'function'){
        if(!SEA.I) throw 'No signing key.';
        pair = await SEA.I(null, {what: data, how: 'sign', why: opt.why});
      }

      var j = await S.parse(data);
      var c = opt.check = opt.check || j;

      if(SEA.verify && (S.check(c) || (c && c.s && c.m))
      && u !== await SEA.verify(c, pair)){
        return n(await S.parse(c), opt, cb);
      }

      if(typeof pair === 'function') {
        var r = await pair(data);
        return r.authenticatorData ? w(r, j, opt, cb) : 
          n({m: j, s: typeof r === 'string' ? r : 
            r.signature && shim.Buffer.from(r.signature, 'binary').toString(opt.encode || 'base64')}, opt, cb);
      }

      return k(pair, j, opt, cb);
    } catch(e) {
      SEA.err = e;
      if(SEA.throw){ throw e }
      if(cb){ cb() }
      return;
    }});

    module.exports = SEA.sign;
  })(USE, './sign');

  ;USE(function(module){
    var SEA = USE('./root');
    var shim = USE('./shim');
    var S = USE('./settings');
    var sha = USE('./sha256');
    var b62 = SEA.base62;
    var u;

    async function w(j, k, s) {
      var a = new Uint8Array(shim.Buffer.from(j.a, 'base64'));
      var c = shim.Buffer.from(j.c, 'base64').toString('utf8');
      var m = new TextEncoder().encode(j.m);
      var e = btoa(String.fromCharCode(...new Uint8Array(m))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
      if (JSON.parse(c).challenge !== e) throw "Challenge verification failed";
      var h = await (shim.ossl || shim.subtle).digest(
          {name: 'SHA-256'},
          new TextEncoder().encode(c)
      );
      var d = new Uint8Array(a.length + h.byteLength);
      d.set(a);
      d.set(new Uint8Array(h), a.length);
      if (s[0] !== 0x30) throw "Invalid DER signature format";
      var o = 2, r = new Uint8Array(64);
      for(var i = 0; i < 2; i++) {
        var l = s[o + 1];
        o += 2;
        if (s[o] === 0x00) { o++; l--; }
        var p = new Uint8Array(32).fill(0);
        p.set(s.slice(o, o + l), 32 - l);
        r.set(p, i * 32);
        o += l;
      }
      return (shim.ossl || shim.subtle).verify({ name: 'ECDSA', hash: {name: 'SHA-256'} }, k, r, d);
    }

    async function v(j, k, s, h) {
      return (shim.ossl || shim.subtle).verify(
        {name: 'ECDSA', hash: {name: 'SHA-256'}}, 
        k, s, new Uint8Array(h)
      );
    }

    SEA.verify = SEA.verify || (async (d, p, cb, o) => { try {
      var j = await S.parse(d);
      if(false === p) return cb ? cb(await S.parse(j.m)) : await S.parse(j.m);

      o = o || {};
      var pub = p.pub || p;
      var xy = b62.pubToJwkXY(pub);
      var x = xy.x, y = xy.y;

      try {
        var k = await (shim.ossl || shim.subtle).importKey('jwk', {
            kty: 'EC', crv: 'P-256', x, y, ext: true, key_ops: ['verify']
        }, {name: 'ECDSA', namedCurve: 'P-256'}, false, ['verify']);

        var h = await sha(j.m);
        var s = new Uint8Array(shim.Buffer.from(j.s || '', o.encode || 'base64'));

        var c = j.a && j.c ? await w(j, k, s) : await v(j, k, s, h);

        if(!c) throw "Signature did not match";

        // Parse the message content
        var r = await S.parse(j.m);

        // Handle encrypted data consistently
        // SEA encrypted data can be in two formats:
        // 1. A string starting with 'SEA' followed by JSON (e.g., 'SEA{"ct":"...","iv":"...","s":"..."}')
        // 2. An object with ct, iv, and s properties

        // Case 1: Original message was already in SEA string format
        if(typeof j.m === 'string' && j.m.startsWith('SEA{')) {
          if(cb){ try{ cb(j.m) }catch(e){} }
          return j.m;
        }

        // Case 2: Result is an encrypted data object
        // This ensures consistent formatting of encrypted data as SEA strings
        if(r && typeof r === 'object' && 
           typeof r.ct === 'string' && 
           typeof r.iv === 'string' && 
           typeof r.s === 'string') {
          // Format as standard SEA encrypted string
          var seaStr = 'SEA' + JSON.stringify(r);
          if(cb){ try{ cb(seaStr) }catch(e){} }
          return seaStr;
        }

        // Default case: Return parsed result as is
        if(cb){ try{ cb(r) }catch(e){} }
        return r;
      } catch(e) {
        if(SEA.opt.fallback){
            return await SEA.opt.fall_verify(d, p, cb, o);
        }
        if(cb){ cb() }
        return;
      }
    } catch(e) {
      SEA.err = e;
      if(SEA.throw){ throw e }
      if(cb){ cb() }
      return;
    }});

    module.exports = SEA.verify;

    var knownKeys = {};
    SEA.opt.slow_leak = pair => {
      if (knownKeys[pair]) return knownKeys[pair];
      var jwk = S.jwk(pair);
      knownKeys[pair] = (shim.ossl || shim.subtle).importKey("jwk", jwk, {name: 'ECDSA', namedCurve: 'P-256'}, false, ["verify"]);
      return knownKeys[pair];
    };

    SEA.opt.fall_verify = async function(data, pair, cb, opt, f){
      if(f === SEA.opt.fallback){ throw "Signature did not match" }
      var tmp = data||'';
      data = SEA.opt.unpack(data) || data;
      var json = await S.parse(data), key = await SEA.opt.slow_leak(pair.pub || pair);
      var hash = (!f || f <= SEA.opt.fallback)? 
        shim.Buffer.from(await shim.subtle.digest({name: 'SHA-256'}, 
          new shim.TextEncoder().encode(await S.parse(json.m)))) : await sha(json.m);

      try {
        var buf = shim.Buffer.from(json.s, opt.encode || 'base64');
        var sig = new Uint8Array(buf);
        var check = await (shim.ossl || shim.subtle).verify(
          {name: 'ECDSA', hash: {name: 'SHA-256'}}, 
          key, sig, new Uint8Array(hash)
        );
        if(!check) throw "";
      } catch(e) {
        try {
          buf = shim.Buffer.from(json.s, 'utf8');
          sig = new Uint8Array(buf);
          check = await (shim.ossl || shim.subtle).verify(
            {name: 'ECDSA', hash: {name: 'SHA-256'}}, 
            key, sig, new Uint8Array(hash)
          );
          if(!check) throw "";
        } catch(e){ throw "Signature did not match." }
      }

      var r = check ? await S.parse(json.m) : u;
      SEA.opt.fall_soul = tmp['#']; SEA.opt.fall_key = tmp['.'];
      SEA.opt.fall_val = data; SEA.opt.fall_state = tmp['>'];
      if(cb){ try{ cb(r) }catch(e){console.log(e)} }
      return r;
    }
    SEA.opt.fallback = 2;
  })(USE, './verify');

  ;USE(function(module){
    var shim = USE('./shim');
    var S = USE('./settings');
    var sha256hash = USE('./sha256');

    const importGen = async (key, salt, opt) => {
      //const combo = shim.Buffer.concat([shim.Buffer.from(key, 'utf8'), salt || shim.random(8)]).toString('utf8') // old
      opt = opt || {};
      const combo = key + (salt || shim.random(8)).toString('utf8'); // new
      const hash = shim.Buffer.from(await sha256hash(combo), 'binary')

      const jwkKey = S.keyToJwk(hash)      
      return await shim.subtle.importKey('jwk', jwkKey, {name:'AES-GCM'}, false, ['encrypt', 'decrypt'])
    }
    module.exports = importGen;
  })(USE, './aeskey');

  ;USE(function(module){
    var SEA = USE('./root');
    var shim = USE('./shim');
    var S = USE('./settings');
    var aeskey = USE('./aeskey');
    var u;

    SEA.encrypt = SEA.encrypt || (async (data, pair, cb, opt) => { try {
      opt = opt || {};
      var key = (pair||opt).epriv || pair;
      if(u === data){ throw '`undefined` not allowed.' }
      if(!key){
        if(!SEA.I){ throw 'No encryption key.' }
        pair = await SEA.I(null, {what: data, how: 'encrypt', why: opt.why});
        key = pair.epriv || pair;
      }
      var msg = (typeof data == 'string')? data : await shim.stringify(data);
      var rand = {s: shim.random(9), iv: shim.random(15)}; // consider making this 9 and 15 or 18 or 12 to reduce == padding.
      var ct = await aeskey(key, rand.s, opt).then((aes) => (/*shim.ossl ||*/ shim.subtle).encrypt({ // Keeping the AES key scope as private as possible...
        name: opt.name || 'AES-GCM', iv: new Uint8Array(rand.iv)
      }, aes, new shim.TextEncoder().encode(msg)));
      var r = {
        ct: shim.Buffer.from(ct, 'binary').toString(opt.encode || 'base64'),
        iv: rand.iv.toString(opt.encode || 'base64'),
        s: rand.s.toString(opt.encode || 'base64')
      }
      if(!opt.raw){ r = 'SEA' + await shim.stringify(r) }

      if(cb){ try{ cb(r) }catch(e){console.log(e)} }
      return r;
    } catch(e) { 
      console.log(e);
      SEA.err = e;
      if(SEA.throw){ throw e }
      if(cb){ cb() }
      return;
    }});

    module.exports = SEA.encrypt;
  })(USE, './encrypt');

  ;USE(function(module){
    var SEA = USE('./root');
    var shim = USE('./shim');
    var S = USE('./settings');
    var aeskey = USE('./aeskey');

    SEA.decrypt = SEA.decrypt || (async (data, pair, cb, opt) => { try {
      opt = opt || {};
      var key = (pair||opt).epriv || pair;
      if(!key){
        if(!SEA.I){ throw 'No decryption key.' }
        pair = await SEA.I(null, {what: data, how: 'decrypt', why: opt.why});
        key = pair.epriv || pair;
      }
      var json = await S.parse(data);
      var buf, bufiv, bufct; try{
        buf = shim.Buffer.from(json.s, opt.encode || 'base64');
        bufiv = shim.Buffer.from(json.iv, opt.encode || 'base64');
        bufct = shim.Buffer.from(json.ct, opt.encode || 'base64');
        var ct = await aeskey(key, buf, opt).then((aes) => (/*shim.ossl ||*/ shim.subtle).decrypt({  // Keeping aesKey scope as private as possible...
          name: opt.name || 'AES-GCM', iv: new Uint8Array(bufiv), tagLength: 128
        }, aes, new Uint8Array(bufct)));
      }catch(e){
        if('utf8' === opt.encode){ throw "Could not decrypt" }
        if(SEA.opt.fallback){
          opt.encode = 'utf8';
          return await SEA.decrypt(data, pair, cb, opt);
        }
      }
      var r = await S.parse(new shim.TextDecoder('utf8').decode(ct));
      if(cb){ try{ cb(r) }catch(e){console.log(e)} }
      return r;
    } catch(e) { 
      console.log(e);
      SEA.err = e;
      if(SEA.throw){ throw e }
      if(cb){ cb() }
      return;
    }});

    module.exports = SEA.decrypt;
  })(USE, './decrypt');

  ;USE(function(module){
    var SEA = USE('./root');
    var shim = USE('./shim');
    var S = USE('./settings');
    var b62 = SEA.base62;
    // Derive shared secret from other's pub and my epub/epriv 
    SEA.secret = SEA.secret || (async (key, pair, cb, opt) => { try {
      opt = opt || {};
      if(!pair || !pair.epriv || !pair.epub){
        if(!SEA.I){ throw 'No secret mix.' }
        pair = await SEA.I(null, {what: key, how: 'secret', why: opt.why});
      }
      var pub = key.epub || key;
      var epub = pair.epub;
      var epriv = pair.epriv;
      var ecdhSubtle = shim.ossl || shim.subtle;
      var pubKeyData = keysToEcdhJwk(pub);
      var props = Object.assign({ public: await ecdhSubtle.importKey(...pubKeyData, true, []) },{name: 'ECDH', namedCurve: 'P-256'}); // Thanks to @sirpy !
      var privKeyData = keysToEcdhJwk(epub, epriv);
      var derived = await ecdhSubtle.importKey(...privKeyData, false, ['deriveBits']).then(async (privKey) => {
        // privateKey scope doesn't leak out from here!
        var derivedBits = await ecdhSubtle.deriveBits(props, privKey, 256);
        var rawBits = new Uint8Array(derivedBits);
        var derivedKey = await ecdhSubtle.importKey('raw', rawBits,{ name: 'AES-GCM', length: 256 }, true, [ 'encrypt', 'decrypt' ]);
        return ecdhSubtle.exportKey('jwk', derivedKey).then(({ k }) => k);
      })
      var r = derived;
      if(cb){ try{ cb(r) }catch(e){console.log(e)} }
      return r;
    } catch(e) {
      console.log(e);
      SEA.err = e;
      if(SEA.throw){ throw e }
      if(cb){ cb() }
      return;
    }});

    // can this be replaced with settings.jwk?
    var keysToEcdhJwk = (pub, d) => { // d === epriv
      var xy = b62.pubToJwkXY(pub) // handles old (87) and new (88) format
      var x = xy.x, y = xy.y
      // Convert base62 epriv (44-char) back to base64url for WebCrypto JWK importKey
      var dJwk = d ? ((d.length === 44 && /^[A-Za-z0-9]{44}$/.test(d)) ? b62.b62ToB64(d) : d) : undefined
      var jwk = dJwk ? { d: dJwk } : {}
      return [  // Use with spread returned value...
        'jwk',
        Object.assign(
          jwk,
          { x: x, y: y, kty: 'EC', crv: 'P-256', ext: true }
        ), // ??? refactor
        {name: 'ECDH', namedCurve: 'P-256'}
      ]
    }

    module.exports = SEA.secret;
  })(USE, './secret');

  ;USE(function(module){
    var SEA = USE('./root');
    // This is to certify that a group of "certificants" can "put" anything at a group of matched "paths" to the certificate authority's graph
    SEA.certify = SEA.certify || (async (certificants, policy = {}, authority, cb, opt = {}) => { try {
      /*
      The Certify Protocol was made out of love by a Vietnamese code enthusiast. Vietnamese people around the world deserve respect!
      IMPORTANT: A Certificate is like a Signature. No one knows who (authority) created/signed a cert until you put it into their graph.
      "certificants": '*' or a String (Bob.pub) || an Object that contains "pub" as a key || an array of [object || string]. These people will have the rights.
      "policy": A string ('inbox'), or a RAD/LEX object {'*': 'inbox'}, or an Array of RAD/LEX objects or strings. RAD/LEX object can contain key "?" with indexOf("*") > -1 to force key equals certificant pub. This rule is used to check against soul+'/'+key using Gun.text.match or String.match.
      "authority": Key pair or priv of the certificate authority.
      "cb": A callback function after all things are done.
      "opt": If opt.expiry (a timestamp) is set, SEA won't sync data after opt.expiry. If opt.block is set, SEA will look for block before syncing.
      */

      certificants = (() => {
        var data = []
        if (certificants) {
          if ((typeof certificants === 'string' || Array.isArray(certificants)) && certificants.indexOf('*') > -1) return '*'
          if (typeof certificants === 'string') return certificants
          if (Array.isArray(certificants)) {
            if (certificants.length === 1 && certificants[0]) return typeof certificants[0] === 'object' && certificants[0].pub ? certificants[0].pub : typeof certificants[0] === 'string' ? certificants[0] : null
            certificants.map(certificant => {
              if (typeof certificant ==='string') data.push(certificant)
              else if (typeof certificant === 'object' && certificant.pub) data.push(certificant.pub)
            })
          }

          if (typeof certificants === 'object' && certificants.pub) return certificants.pub
          return data.length > 0 ? data : null
        }
        return
      })()

      if (!certificants) return console.log("No certificant found.")

      const expiry = opt.expiry && (typeof opt.expiry === 'number' || typeof opt.expiry === 'string') ? parseFloat(opt.expiry) : null
      const readPolicy = (policy || {}).read ? policy.read : null
      const writePolicy = (policy || {}).write ? policy.write : typeof policy === 'string' || Array.isArray(policy) || policy["+"] || policy["#"] || policy["."] || policy["="] || policy["*"] || policy[">"] || policy["<"] ? policy : null
      // The "blacklist" feature is now renamed to "block". Why ? BECAUSE BLACK LIVES MATTER!
      // We can now use 3 keys: block, blacklist, ban
      const block = (opt || {}).block || (opt || {}).blacklist || (opt || {}).ban || {}
      const readBlock = block.read && (typeof block.read === 'string' || (block.read || {})['#']) ? block.read : null
      const writeBlock = typeof block === 'string' ? block : block.write && (typeof block.write === 'string' || block.write['#']) ? block.write : null

      if (!readPolicy && !writePolicy) return console.log("No policy found.")

      // reserved keys: c, e, r, w, rb, wb
      const data = JSON.stringify({
        c: certificants,
        ...(expiry ? {e: expiry} : {}), // inject expiry if possible
        ...(readPolicy ? {r: readPolicy }  : {}), // "r" stands for read, which means read permission.
        ...(writePolicy ? {w: writePolicy} : {}), // "w" stands for write, which means write permission.
        ...(readBlock ? {rb: readBlock} : {}), // inject READ block if possible
        ...(writeBlock ? {wb: writeBlock} : {}), // inject WRITE block if possible
      })

      const certificate = await SEA.sign(data, authority, null, {raw:1})

      var r = certificate
      if(!opt.raw){ r = 'SEA'+JSON.stringify(r) }
      if(cb){ try{ cb(r) }catch(e){console.log(e)} }
      return r;
    } catch(e) {
      SEA.err = e;
      if(SEA.throw){ throw e }
      if(cb){ cb() }
      return;
    }});

    module.exports = SEA.certify;
  })(USE, './certify');

  ;USE(function(module){
    var shim = USE('./shim');
    var sha1hash = USE('./sha1');
    // Practical examples about usage found in tests.
    var SEA = USE('./root');
    SEA.work = USE('./work');
    SEA.sign = USE('./sign');
    SEA.verify = USE('./verify');
    SEA.encrypt = USE('./encrypt');
    SEA.decrypt = USE('./decrypt');
    SEA.certify = USE('./certify');
    //SEA.opt.aeskey = USE('./aeskey'); // not official! // this causes problems in latest WebCrypto.

    SEA.random = SEA.random || shim.random;

    // This is Buffer used in SEA and usable from Gun/SEA application also.
    // For documentation see https://nodejs.org/api/buffer.html
    SEA.Buffer = SEA.Buffer || USE('./buffer');

    // These SEA functions support now ony Promises or
    // async/await (compatible) code, use those like Promises.
    //
    // Creates a wrapper library around Web Crypto API
    // for various AES, ECDSA, PBKDF2 functions we called above.
    // Calculate public key KeyID aka PGPv4 (result: 8 bytes as hex string)
    SEA.keyid = SEA.keyid || (async (pub) => {
      try {
        // Decode pub key coordinates (handles old 87-char base64url and new 88-char base62)
        var xy = SEA.base62.pubToJwkXY(pub);
        const pb = shim.Buffer.concat(
          [xy.x, xy.y].map((t) => shim.Buffer.from(atob(t.replace(/-/g,'+').replace(/_/g,'/')), 'binary'))
        )
        // id is PGPv4 compliant raw key
        const id = shim.Buffer.concat([
          shim.Buffer.from([0x99, pb.length / 0x100, pb.length % 0x100]), pb
        ])
        const sha1 = await sha1hash(id)
        const hash = shim.Buffer.from(sha1, 'binary')
        return hash.toString('hex', hash.length - 8)  // 16-bit ID as hex
      } catch (e) {
        console.log(e)
        throw e
      }
    });
    // all done!
    // Obviously it is missing MANY necessary features. This is only an alpha release.
    // Please experiment with it, audit what I've done so far, and complain about what needs to be added.
    // SEA should be a full suite that is easy and seamless to use.
    // Again, scroll naer the top, where I provide an EXAMPLE of how to create a user and sign in.
    // Once logged in, the rest of the code you just read handled automatically signing/validating data.
    // But all other behavior needs to be equally easy, like opinionated ways of
    // Adding friends (trusted public keys), sending private messages, etc.
    // Cheers! Tell me what you think.
    ((SEA.window||{}).GUN||{}).SEA = SEA;

    module.exports = SEA
    // -------------- END SEA MODULES --------------------
    // -- BEGIN SEA+GUN MODULES: BUNDLED BY DEFAULT UNTIL OTHERS USE SEA ON OWN -------
  })(USE, './sea');

  ;USE(function(module){
    var SEA = USE('./sea'), Gun, u;
    if(SEA.window){
      Gun = SEA.window.GUN || {chain:{}};
    } else {
      Gun = USE((u+'' == typeof MODULE?'.':'')+'./gun', 1);
    }
    SEA.GUN = Gun;

    function User(root){ 
      this._ = {$: this};
    }
    User.prototype = (function(){ function F(){}; F.prototype = Gun.chain; return new F() }()) // Object.create polyfill
    User.prototype.constructor = User;

    // let's extend the gun chain with a `user` function.
    // only one user can be logged in at a time, per gun instance.
    Gun.chain.user = function(pub){
      var gun = this, root = gun.back(-1), user;
      if(pub){
        pub = SEA.opt.pub((pub._||'')['#']) || pub;
        return root.get('~'+pub);
      }
      if(user = root.back('user')){ return user }
      var root = (root._), at = root, uuid = at.opt.uuid || lex;
      (at = (user = at.user = gun.chain(new User))._).opt = {};
      at.opt.uuid = function(cb){
        var id = uuid(), pub = root.user;
        if(!pub || !(pub = pub.is) || !(pub = pub.pub)){ return id }
        id = '~' + pub + '/' + id;
        if(cb && cb.call){ cb(null, id) }
        return id;
      }
      return user;
    }
    function lex(){ return Gun.state().toString(36).replace('.','') }
    Gun.User = User;
    User.GUN = Gun;
    User.SEA = Gun.SEA = SEA;
    module.exports = User;
  })(USE, './user');

  ;USE(function(module){
    var u, Gun = (''+u != typeof GUN)? (GUN||{chain:{}}) : USE((''+u === typeof MODULE?'.':'')+'./gun', 1);
    Gun.chain.then = function(cb, opt){
      var gun = this, p = (new Promise(function(res, rej){
        gun.once(res, opt);
      }));
      return cb? p.then(cb) : p;
    }
  })(USE, './then');

  ;USE(function(module){
    var User = USE('./user'), SEA = User.SEA, Gun = User.GUN, noop = function(){};

    // Well first we have to actually create a user. That is what this function does.
    User.prototype.create = function(...args){
      var pair = typeof args[0] === 'object' && (args[0].pub || args[0].epub) ? args[0] : typeof args[1] === 'object' && (args[1].pub || args[1].epub) ? args[1] : null;
      var alias = pair && (pair.pub || pair.epub) ? pair.pub : typeof args[0] === 'string' ? args[0] : null;
      var pass = pair && (pair.pub || pair.epub) ? pair : alias && typeof args[1] === 'string' ? args[1] : null;
      var cb = args.filter(arg => typeof arg === 'function')[0] || null; // cb now can stand anywhere, after alias/pass or pair
      var opt = args && args.length > 1 && typeof args[args.length-1] === 'object' ? args[args.length-1] : {}; // opt is always the last parameter which typeof === 'object' and stands after cb

      var gun = this, cat = (gun._), root = gun.back(-1);
      cb = cb || noop;
      opt = opt || {};
      if(false !== opt.check){
        var err;
        if(!alias){ err = "No user." }
        if((pass||'').length < 8){ err = "Password too short!" }
        if(err){
          cb({err: Gun.log(err)});
          return gun;
        }
      }
      if(cat.ing){
        (cb || noop)({err: Gun.log("User is already being created or authenticated!"), wait: true});
        return gun;
      }
      cat.ing = true;
      var act = {}, u;
      act.a = function(pubs){
        act.pubs = pubs;
        if(pubs && !opt.already){
          // If we can enforce that a user name is already taken, it might be nice to try, but this is not guaranteed.
          var ack = {err: Gun.log('User already created!')};
          cat.ing = false;
          (cb || noop)(ack);
          gun.leave();
          return;
        }
        act.salt = String.random(64); // pseudo-randomly create a salt, then use PBKDF2 function to extend the password with it.
        SEA.work(pass, act.salt, act.b); // this will take some short amount of time to produce a proof, which slows brute force attacks.
      }
      act.b = function(proof){
        act.proof = proof;
        pair ? act.c(pair) : SEA.pair(act.c) // generate a brand new key pair or use the existing.
      }
      act.c = function(pair){
        var tmp
        act.pair = pair || {};
        if(tmp = cat.root.user){
          tmp._.sea = pair;
          tmp.is = {pub: pair.pub, epub: pair.epub, alias: alias};
        }
        // the user's public key doesn't need to be signed. But everything else needs to be signed with it! // we have now automated it! clean up these extra steps now!
        act.data = {pub: pair.pub};
        act.d();
      }
      act.d = function(){
        act.data.alias = alias;
        act.e();
      }
      act.e = function(){
        act.data.epub = act.pair.epub; 
        SEA.encrypt({priv: act.pair.priv, epriv: act.pair.epriv}, act.proof, act.f, {raw:1}); // to keep the private key safe, we AES encrypt it with the proof of work!
      }
      act.f = function(auth){
        act.data.auth = JSON.stringify({ek: auth, s: act.salt}); 
        act.g(act.data.auth);
      }
      act.g = function(auth){ var tmp;
        act.data.auth = act.data.auth || auth;
        root.get(tmp = '~'+act.pair.pub).put(act.data).on(act.h); // awesome, now we can actually save the user with their public key as their ID.
        var link = {}; link[tmp] = {'#': tmp}; root.get('~@'+alias).put(link).get(tmp).on(act.i); // next up, we want to associate the alias with the public key. So we add it to the alias list.
      }
      act.h = function(data, key, msg, eve){
        eve.off(); act.h.ok = 1; act.i();
      }
      act.i = function(data, key, msg, eve){
        if(eve){ act.i.ok = 1; eve.off() }
        if(!act.h.ok || !act.i.ok){ return }
        cat.ing = false;
        cb({ok: 0, pub: act.pair.pub}); // callback that the user has been created. (Note: ok = 0 because we didn't wait for disk to ack)
        if(noop === cb){ pair ? gun.auth(pair) : gun.auth(alias, pass) } // if no callback is passed, auto-login after signing up.
      }
      root.get('~@'+alias).once(act.a);
      return gun;
    }
    User.prototype.leave = function(opt, cb){
      var gun = this, user = (gun.back(-1)._).user;
      if(user){
        delete user.is;
        delete user._.is;
        delete user._.sea;
      }
      if(SEA.window){
        try{var sS = {};
        sS = SEA.window.sessionStorage;
        delete sS.recall;
        delete sS.pair;
        }catch(e){};
      }
      return gun;
    }
  })(USE, './create');

  ;USE(function(module){
    var User = USE('./user'), SEA = User.SEA, Gun = User.GUN, noop = function(){};
    // now that we have created a user, we want to authenticate them!
    User.prototype.auth = function(...args){ // TODO: this PR with arguments need to be cleaned up / refactored.
      var pair = typeof args[0] === 'object' && (args[0].pub || args[0].epub) ? args[0] : typeof args[1] === 'object' && (args[1].pub || args[1].epub) ? args[1] : null;
      var alias = !pair && typeof args[0] === 'string' ? args[0] : null;
      var pass = (alias || (pair && !(pair.priv && pair.epriv))) && typeof args[1] === 'string' ? args[1] : null;
      var cb = args.filter(arg => typeof arg === 'function')[0] || null; // cb now can stand anywhere, after alias/pass or pair
      var opt = args && args.length > 1 && typeof args[args.length-1] === 'object' ? args[args.length-1] : {}; // opt is always the last parameter which typeof === 'object' and stands after cb
      var retries = typeof opt.retries === 'number' ? opt.retries : 9;

      var gun = this, cat = (gun._), root = gun.back(-1);

      if(cat.ing){
        (cb || noop)({err: Gun.log("User is already being created or authenticated!"), wait: true});
        return gun;
      }
      cat.ing = true;

      var act = {}, u;
      act.a = function(data){
        if(!data){ return act.b() }
        if(!data.pub){
          var tmp = []; Object.keys(data).forEach(function(k){ if('_'==k){ return } tmp.push(data[k]) })
          return act.b(tmp);
        }
        if(act.name){ return act.f(data) }
        act.c((act.data = data).auth);
      }
      act.b = function(list){
        var get = (act.list = (act.list||[]).concat(list||[])).shift();
        if(u === get){
          if(act.name){ return act.err('Your user account is not published for dApps to access, please consider syncing it online, or allowing local access by adding your device as a peer.') }
          if(alias && retries--){
            act.enc = u; act.legacy = false; act.base64 = false; // reset for retry
            root.get('~@'+alias).once(act.a);
            return;
          }
          return act.err('Wrong user or password.') 
        }
        root.get(get).once(act.a);
      }
      act.c = function(auth){
        if(u === auth){ return act.b() }
        if('string' == typeof auth){
          // SEA{...} format needs prefix-stripped parse; plain JSON handled by obj_ify
          if('SEA{' === auth.slice(0,4)){
            SEA.opt.parse(auth).then(function(env){ // env = {m: innerJSON, s: sig}
              if(!env || !env.m){ return act.c(obj_ify(auth)) }
              // env.m may be a string (bob) or array [soul, key, json, ts] (alice legacy [])
              var payload = Array.isArray(env.m) ? env.m[2] : env.m;
              act.c(obj_ify(payload)); // parse the inner {ek, s} payload
            });
            return;
          }
          return act.c(obj_ify(auth));
        }
        SEA.work(pass, (act.auth = auth).s, act.d, act.enc); // the proof of work is evidence that we've spent some time/effort trying to log in, this slows brute force.
      }
      act.d = function(proof){
        act.proof = proof;
        SEA.decrypt(act.auth.ek, proof, act.e, act.enc);
      }
      act.e = function(half){
        if(u === half){
          if(!act.enc){ // try utf8 (common legacy format)
            act.enc = {encode: 'utf8'};
            return act.c(act.auth);
          }
          if(!act.base64){ // try base64url (old default pre-base62, shimmed btoa)
            act.base64 = true; // use flag, not enc check — decrypt.js mutates enc.encode via fallback
            act.enc = {encode: 'base64'};
            return act.c(act.auth);
          }
          if(!act.legacy && act.proof){ // convert base64url proof -> standard base64 (pre-shim era, e.g. 2019 browser users)
            act.legacy = true;
            var tmp = act.proof.replace(/-/g, '+').replace(/_/g, '/');
            while(tmp.length % 4){ tmp += '=' }
            return SEA.decrypt(act.auth.ek, tmp, act.e, {encode: 'base64'}); // fresh opt: act.enc may be mutated by decrypt's internal fallback
          }
          act.enc = null; // end backwards
          return act.b();
        }
        act.half = half;
        act.f(act.data);
      }
      act.f = function(pair){
        var half = act.half || {}, data = act.data || {};
        act.g(act.lol = {pub: pair.pub || data.pub, epub: pair.epub || data.epub, priv: pair.priv || half.priv, epriv: pair.epriv || half.epriv});
      }
      act.g = function(pair){
        if(!pair || !pair.pub || !pair.epub){ return act.b() }
        act.pair = pair;
        var user = (root._).user, at = (user._);
        var tmp = at.tag;
        var upt = at.opt;
        at = user._ = root.get('~'+pair.pub)._;
        at.opt = upt;
        // add our credentials in-memory only to our root user instance
        user.is = {pub: pair.pub, epub: pair.epub, alias: alias || pair.pub};
        at.sea = act.pair;
        cat.ing = false;
        try{if(pass && u == (obj_ify(cat.root.graph['~'+pair.pub].auth)||'')[':']){ opt.shuffle = opt.change = pass; } }catch(e){} // migrate UTF8 & Shuffle!
        opt.change? act.z() : (cb || noop)(at);
        if(SEA.window && ((gun.back('user')._).opt||opt).remember){
          // TODO: this needs to be modular.
          try{var sS = {};
          sS = SEA.window.sessionStorage; // TODO: FIX BUG putting on `.is`!
          sS.recall = true;
          sS.pair = JSON.stringify(pair); // auth using pair is more reliable than alias/pass
          }catch(e){}
        }
        try{
          if(root._.tag.auth){ // auth handle might not be registered yet
          (root._).on('auth', at) // TODO: Deprecate this, emit on user instead! Update docs when you do.
          } else { setTimeout(function(){ (root._).on('auth', at) },1) } // if not, hackily add a timeout.
          //at.on('auth', at) // Arrgh, this doesn't work without event "merge" code, but "merge" code causes stack overflow and crashes after logging in & trying to write data.
        }catch(e){
          Gun.log("Your 'auth' callback crashed with:", e);
        }
      }
      act.h = function(data){
        if(!data){ return act.b() }
        alias = data.alias
        if(!alias)
          alias = data.alias = "~" + pair.pub        
        if(!data.auth){
          return act.g(pair);
        }
        pair = null;
        act.c((act.data = data).auth);
      }
      act.z = function(){
        // password update so encrypt private key using new pwd + salt
        act.salt = String.random(64); // pseudo-random
        SEA.work(opt.change, act.salt, act.y);
      }
      act.y = function(proof){
        SEA.encrypt({priv: act.pair.priv, epriv: act.pair.epriv}, proof, act.x, {raw:1});
      }
      act.x = function(auth){
        act.w(JSON.stringify({ek: auth, s: act.salt}));
      }
      act.w = function(auth){
        if(opt.shuffle){ // delete in future!
          console.log('migrate core account from UTF8 & shuffle');
          var tmp = {}; Object.keys(act.data).forEach(function(k){ tmp[k] = act.data[k] });
          delete tmp._;
          tmp.auth = auth;
          root.get('~'+act.pair.pub).put(tmp);
        } // end delete
        root.get('~'+act.pair.pub).get('auth').put(auth, cb || noop);
      }
      act.err = function(e){
        var ack = {err: Gun.log(e || 'User cannot be found!')};
        cat.ing = false;
        (cb || noop)(ack);
      }
      act.plugin = function(name){
        if(!(act.name = name)){ return act.err() }
        var tmp = [name];
        if('~' !== name[0]){
          tmp[1] = '~'+name;
          tmp[2] = '~@'+name;
        }
        act.b(tmp);
      }
      if(pair){
        if(pair.priv && pair.epriv)
          act.g(pair);
        else
          root.get('~'+pair.pub).once(act.h);
      } else
      if(alias){
        root.get('~@'+alias).once(act.a);
      } else
      if(!alias && !pass){
        SEA.name(act.plugin);
      }
      return gun;
    }
    function obj_ify(o){
      if('string' != typeof o){ return o }
      try{o = JSON.parse(o);
      }catch(e){o={}};
      return o;
    }
  })(USE, './auth');

  ;USE(function(module){
    var User = USE('./user'), SEA = User.SEA, Gun = User.GUN;
    User.prototype.recall = function(opt, cb){
      var gun = this, root = gun.back(-1), tmp;
      opt = opt || {};
      if(opt && opt.sessionStorage){
        if(SEA.window){
          try{
            var sS = {};
            sS = SEA.window.sessionStorage; // TODO: FIX BUG putting on `.is`!
            if(sS){
              (root._).opt.remember = true;
              ((gun.back('user')._).opt||opt).remember = true;
              if(sS.recall || sS.pair) root.user().auth(JSON.parse(sS.pair), cb); // pair is more reliable than alias/pass
            }
          }catch(e){}
        }
        return gun;
      }
      /*
        TODO: copy mhelander's expiry code back in.
        Although, we should check with community,
        should expiry be core or a plugin?
      */
      return gun;
    }
  })(USE, './recall');

  ;USE(function(module){
    var User = USE('./user'), SEA = User.SEA, Gun = User.GUN, noop = function(){};
    User.prototype.pair = function(){
      var user = this, proxy; // undeprecated, hiding with proxies.
      try{ proxy = new Proxy({DANGER:'\u2620'}, {get: function(t,p,r){
        if(!user.is || !(user._||'').sea){ return }
        return user._.sea[p];
      }})}catch(e){}
      return proxy;
    }
    // If authenticated user wants to delete his/her account, let's support it!
    User.prototype.delete = async function(alias, pass, cb){
      console.log("user.delete() IS DEPRECATED AND WILL BE MOVED TO A MODULE!!!");
      var gun = this, root = gun.back(-1), user = gun.back('user');
      try {
        user.auth(alias, pass, function(ack){
          var pub = (user.is||{}).pub;
          // Delete user data
          user.map().once(function(){ this.put(null) });
          // Wipe user data from memory
          user.leave();
          (cb || noop)({ok: 0});
        });
      } catch (e) {
        Gun.log('User.delete failed! Error:', e);
      }
      return gun;
    }
    User.prototype.alive = async function(){
      console.log("user.alive() IS DEPRECATED!!!");
      const gunRoot = this.back(-1)
      try {
        // All is good. Should we do something more with actual recalled data?
        await authRecall(gunRoot)
        return gunRoot._.user._
      } catch (e) {
        const err = 'No session!'
        Gun.log(err)
        throw { err }
      }
    }
    User.prototype.trust = async function(user){
      console.log("`.trust` API MAY BE DELETED OR CHANGED OR RENAMED, DO NOT USE!");
      // TODO: BUG!!! SEA `node` read listener needs to be async, which means core needs to be async too.
      //gun.get('alice').get('age').trust(bob);
      if (Gun.is(user)) {
        user.get('pub').get((ctx, ev) => {
          console.log(ctx, ev)
        })
      }
      user.get('trust').get(path).put(theirPubkey);

      // do a lookup on this gun chain directly (that gets bob's copy of the data)
      // do a lookup on the metadata trust table for this path (that gets all the pubkeys allowed to write on this path)
      // do a lookup on each of those pubKeys ON the path (to get the collab data "layers")
      // THEN you perform Jachen's mix operation
      // and return the result of that to...
    }
    User.prototype.grant = function(to, cb){
      console.log("`.grant` API MAY BE DELETED OR CHANGED OR RENAMED, DO NOT USE!");
      var gun = this, user = gun.back(-1).user(), pair = user._.sea, path = '';
      gun.back(function(at){ if(at.is){ return } path += (at.get||'') });
      (async function(){
      var enc, sec = await user.get('grant').get(pair.pub).get(path).then();
      sec = await SEA.decrypt(sec, pair);
      if(!sec){
        sec = SEA.random(16).toString();
        enc = await SEA.encrypt(sec, pair);
        user.get('grant').get(pair.pub).get(path).put(enc);
      }
      var pub = to.get('pub').then();
      var epub = to.get('epub').then();
      pub = await pub; epub = await epub;
      var dh = await SEA.secret(epub, pair);
      enc = await SEA.encrypt(sec, dh);
      user.get('grant').get(pub).get(path).put(enc, cb);
      }());
      return gun;
    }
    User.prototype.secret = function(data, cb){
      console.log("`.secret` API MAY BE DELETED OR CHANGED OR RENAMED, DO NOT USE!");
      var gun = this, user = gun.back(-1).user(), pair = user.pair(), path = '';
      gun.back(function(at){ if(at.is){ return } path += (at.get||'') });
      (async function(){
      var enc, sec = await user.get('trust').get(pair.pub).get(path).then();
      sec = await SEA.decrypt(sec, pair);
      if(!sec){
        sec = SEA.random(16).toString();
        enc = await SEA.encrypt(sec, pair);
        user.get('trust').get(pair.pub).get(path).put(enc);
      }
      enc = await SEA.encrypt(data, sec);
      gun.put(enc, cb);
      }());
      return gun;
    }

    /**
     * returns the decrypted value, encrypted by secret
     * @returns {Promise<any>}
     // Mark needs to review 1st before officially supported
    User.prototype.decrypt = function(cb) {
      let gun = this,
        path = ''
      gun.back(function(at) {
        if (at.is) {
          return
        }
        path += at.get || ''
      })
      return gun
        .then(async data => {
          if (data == null) {
            return
          }
          const user = gun.back(-1).user()
          const pair = user.pair()
          let sec = await user
            .get('trust')
            .get(pair.pub)
            .get(path)
          sec = await SEA.decrypt(sec, pair)
          if (!sec) {
            return data
          }
          let decrypted = await SEA.decrypt(data, sec)
          return decrypted
        })
        .then(res => {
          cb && cb(res)
          return res
        })
    }
    */
    module.exports = User
  })(USE, './share');

  ;USE(function(module){
    var SEA = USE('./sea'), S = USE('./settings'), noop = function() {}, u;
    var Gun = (SEA.window||'').GUN || USE((''+u === typeof MODULE?'.':'')+'./gun', 1);
    // After we have a GUN extension to make user registration/login easy, we then need to handle everything else.

    // We do this with a GUN adapter, we first listen to when a gun instance is created (and when its options change)
    Gun.on('opt', function(at){
      if(!at.sea){ // only add SEA once per instance, on the "at" context.
        at.sea = {own: {}};
        at.on('put', check, at); // SEA now runs its firewall on HAM diffs, not all i/o.
      }
      this.to.next(at); // make sure to call the "next" middleware adapter.
    });

    // Alright, this next adapter gets run at the per node level in the graph database.
    // correction: 2020 it gets run on each key/value pair in a node upon a HAM diff.
    // This will let us verify that every property on a node has a value signed by a public key we trust.
    // If the signature does not match, the data is just `undefined` so it doesn't get passed on.
    // If it does match, then we transform the in-memory "view" of the data into its plain value (without the signature).
    // Now NOTE! Some data is "system" data, not user data. Example: List of public keys, aliases, etc.
    // This data is self-enforced (the value can only match its ID), but that is handled in the `security` function.
    // From the self-enforced data, we can see all the edges in the graph that belong to a public key.
    // Example: ~ASDF is the ID of a node with ASDF as its public key, signed alias and salt, and
    // its encrypted private key, but it might also have other signed values on it like `profile = <ID>` edge.
    // Using that directed edge's ID, we can then track (in memory) which IDs belong to which keys.
    // Here is a problem: Multiple public keys can "claim" any node's ID, so this is dangerous!
    // This means we should ONLY trust our "friends" (our key ring) public keys, not any ones.
    // I have not yet added that to SEA yet in this alpha release. That is coming soon, but beware in the meanwhile!

    // --------------- Main dispatcher ---------------
    function check(msg){
      var eve = this, at = eve.as, put = msg.put, soul = put['#'], key = put['.'], val = put[':'], state = put['>'], id = msg['#'], tmp;
      if(!soul || !key){ return }

      // Faith fast-path — bypass all validation
      if((msg._||'').faith && (at.opt||'').faith && 'function' == typeof msg._){
        check.pipe.faith({ eve: eve, msg: msg, put: put, at: at }); return;
      }

      var no = function(why){ at.on('in', {'@': id, err: msg.err = why}) };
      (msg._||'').DBG && ((msg._||'').DBG.c = +new Date);

      // Build context object shared across all stages
      var ctx = { eve: eve, msg: msg, at: at, put: put, soul: soul, key: key, val: val, state: state, id: id, no: no, pub: null };

      // Route: determine which feature stage to run after forget
      var pipeline = [check.pipe.forget];

      if('~@' === soul){
        pipeline.push(check.pipe.alias);
      } else if('~@' === soul.slice(0,2)){
        pipeline.push(check.pipe.pubs);
      } else if('~' === soul || '~/' === soul.slice(0,2)){
        pipeline.push(check.pipe.shard);
      } else if(tmp = SEA.opt.pub(soul)){
        ctx.pub = tmp;
        pipeline.push(check.pipe.pub);
      } else if(0 <= soul.indexOf('#')){
        pipeline.push(check.pipe.hash);
      } else {
        pipeline.push(check.pipe.any);
      }

      // Keep reference to the required security stage before plugins can touch the array
      var required = pipeline[1];

      // Allow plugins to augment/reorder the pipeline
      for(var pi = 0; pi < check.plugins.length; pi++){
        check.plugins[pi](ctx, pipeline);
      }

      // Guard: ensure the routing security stage was not removed by a plugin
      if(required && pipeline.indexOf(required) < 0){ return no("Security stage removed."); }

      check.run(pipeline, ctx);
    }

    // --------------- Pipeline runner ---------------
    // Each stage is fn(ctx, next, reject) where:
    //   next()       = advance to the next stage (or COMMIT if last)
    //   reject(why)  = call no(why) and stop
    // A stage that does NOT call next() or reject() must handle forwarding itself
    // (e.g. stages that call eve.to.next(msg) directly).
    check.run = function(stages, ctx) {
      var no = ctx.no; // snapshot: prevent ctx.no mutation from bypassing rejection
      var i = 0;
      var next = function() {
        if (i >= stages.length) return; // all stages consumed, done
        var stage = stages[i++];
        var spent = false; // guard: each stage may advance the pipeline at most once
        var once = function(){ if(!spent){ spent = true; next(); } };
        try { stage(ctx, once, no); } catch(e) { no(e && e.message || String(e)); }
      };
      next();
    };

    // --------------- Pipeline stages (check.pipe.<name>) ---------------
    // Each stage: fn(ctx, next, reject)
    check.pipe = {
      faith: function(ctx, next, reject) {
        var eve = ctx.eve, msg = ctx.msg, put = ctx.put, at = ctx.at;
        SEA.opt.pack(put, function(raw){
          SEA.verify(raw, false, function(data){
            put['='] = SEA.opt.unpack(data);
            eve.to.next(msg);
          });
        });
      },
      forget: function(ctx, next, reject) {
        var soul = ctx.soul, state = ctx.state, msg = ctx.msg, tmp;
        if(0 <= soul.indexOf('<?')){
          // 'a~pub.key/b<?9'
          tmp = parseFloat(soul.split('<?')[1]||'');
          if(tmp && (state < (Gun.state() - (tmp * 1000)))){ // sec to ms
            (tmp = msg._) && (tmp.stun) && (tmp.stun--); // THIS IS BAD CODE! It assumes GUN internals do something that will probably change in future, but hacking in now.
            return; // omit — do NOT call next()
          }
        }
        next();
      },
      alias:  function(ctx, next, reject) { check.alias(ctx.eve, ctx.msg, ctx.val, ctx.key, ctx.soul, ctx.at, reject); },
      pubs:   function(ctx, next, reject) { check.pubs(ctx.eve, ctx.msg, ctx.val, ctx.key, ctx.soul, ctx.at, reject); },
      shard:  function(ctx, next, reject) { check.shard(ctx.eve, ctx.msg, ctx.val, ctx.key, ctx.soul, ctx.at, reject, ctx.at.user||''); },
      pub:    function(ctx, next, reject) { check.pub(ctx.eve, ctx.msg, ctx.val, ctx.key, ctx.soul, ctx.at, reject, ctx.at.user||'', ctx.pub); },
      hash:   function(ctx, next, reject) { check.hash(ctx.eve, ctx.msg, ctx.val, ctx.key, ctx.soul, ctx.at, reject); },
      any:    function(ctx, next, reject) { check.any(ctx.eve, ctx.msg, ctx.val, ctx.key, ctx.soul, ctx.at, reject, ctx.at.user||''); }
    };

    Object.freeze(check.pipe); // prevent replacement of built-in security stages

    // --------------- Plugin registry ---------------
    // Plugins receive (ctx, pipeline) and may insert/reorder stages.
    // NOTE: plugins cannot remove the routing security stage (validated in check()).
    check.plugins = [];
    check.use = function(fn) { check.plugins.push(fn); };

    // Verify content-addressed data matches its hash
    check.hash = function (eve, msg, val, key, soul, at, no, yes) {
      function base64ToHex(data) {
        var binaryStr = atob(data);
        var a = [];
        for (var i = 0; i < binaryStr.length; i++) {
          var hex = binaryStr.charCodeAt(i).toString(16);
          a.push(hex.length === 1 ? "0" + hex : hex);
        }
        return a.join("");
      }
      var hash = key.split('#').pop();
      yes = yes || function(){ eve.to.next(msg) };
      if(!hash || hash === key){ return yes() }
      SEA.work(val, null, function (b64hash) {
        var hexhash = base64ToHex(b64hash), b64slice = b64hash.slice(-20), hexslice = hexhash.slice(-20);
        if ([b64hash, b64slice, hexhash, hexslice].some(item => item.endsWith(hash))) return yes();
        no("Data hash not same as hash!");
      }, { name: 'SHA-256' });
    }
    check.alias = function(eve, msg, val, key, soul, at, no){ // Example: {_:#~@, ~@alice: {#~@alice}}
      if(!val){ return no("Data must exist!") } // data MUST exist
      if('~@'+key === link_is(val)){ return eve.to.next(msg) } // in fact, it must be EXACTLY equal to itself
      no("Alias not same!"); // if it isn't, reject.
    };
    check.pubs = function(eve, msg, val, key, soul, at, no){ // Example: {_:#~@alice, ~asdf: {#~asdf}}
      if(!val){ return no("Alias must exist!") } // data MUST exist
      if(key === link_is(val)){ return eve.to.next(msg) } // and the ID must be EXACTLY equal to its property
      no("Alias not same!"); // that way nobody can tamper with the list of public keys.
    };
    check.$sh = {
      pub: 88,
      cut: 2,
      min: 1,
      root: '~',
      pre: '~/',
      bad: /[^0-9a-zA-Z]/
    }
    check.$sh.max = Math.ceil(check.$sh.pub / check.$sh.cut)
    check.$seg = function(seg, short){
      if('string' != typeof seg || !seg){ return }
      if(short){
        if(seg.length < check.$sh.min || seg.length > check.$sh.cut){ return }
      } else {
        if(seg.length !== check.$sh.cut){ return }
      }
      if(check.$sh.bad.test(seg)){ return }
      return 1
    }
    check.$path = function(soul){
      if(check.$sh.root === soul){ return [] }
      if(check.$sh.pre !== (soul||'').slice(0,2)){ return }
      if('/' === soul.slice(-1) || 0 <= soul.indexOf('//')){ return }
      var path = soul.slice(2).split('/'), i = 0, seg;
      for(i; i < path.length; i++){
        seg = path[i];
        if(!check.$seg(seg)){ return }
      }
      return path
    }
    check.$kid = function(soul, key){
      if(check.$sh.root === soul){ return check.$sh.pre + key }
      return soul + '/' + key
    }
    check.$pub = function(soul, key){
      var path = check.$path(soul);
      if(!path){ return }
      return path.join('') + key
    }
    check.$leaf = function(soul, key){
      var pub = check.$pub(soul, key);
      if(!pub || pub.length !== check.$sh.pub){ return }
      if(SEA.opt.pub('~' + pub) !== pub){ return }
      return pub
    }
    check.$sea = function(msg, user, pub){
      var ctx = (msg._.msg || {}).opt || {}
      var opt = msg._.sea || (function(){
        var o = Object.assign({}, ctx)
        try{
          Object.defineProperty(msg._, 'sea', {value: o, enumerable: false, configurable: true, writable: true})
        }catch(e){ msg._.sea = o }
        return o
      }())
      var authenticator = opt.authenticator || (user._ || {}).sea
      var upub = opt.authenticator ? (opt.pub || (user.is || {}).pub || pub) : (user.is || {}).pub
      if (!msg._.done) {
        delete ctx.authenticator; delete ctx.pub
        msg._.done = true
      }
      return {opt, authenticator, upub}
    }
    check.shard = async function(eve, msg, val, key, soul, at, no, user){
      var path = check.$path(soul), link = link_is(val), expected, leaf, raw, claim;
      if(!path){ return no("Invalid shard soul path.") }
      if(!check.$seg(key, 1)){ return no("Invalid shard key.") }
      if((path.length + 1) > check.$sh.max){ return no("Invalid shard depth.") }
      leaf = check.$leaf(soul, key)
      if(leaf){
        if(!link){ return no("Shard leaf value must be a link.") }
        if(link !== '~' + leaf){ return no("Shard leaf link must point to ~pub.") }
        // Always sign fresh — authenticator required; sig covers state, preventing pre-signed writes
        var lsec = check.$sea(msg, user, leaf)
        var lauthenticator = lsec.authenticator
        var lupub = lsec.upub || (lauthenticator||{}).pub
        if(!lauthenticator){ return no("Shard leaf requires authenticator.") }
        if(lupub !== leaf){ return no("Shard leaf authenticator pub mismatch.") }
        check.auth(msg, no, lauthenticator, function(data){
          if(link_is(data) !== link){ return no("Shard leaf signed payload mismatch.") }
          msg.put['='] = {'#': link}
          check.next(eve, msg, no)
        })
        return
      }
      // Intermediate
      expected = check.$kid(soul, key)
      var prefix = check.$pub(soul, key)
      raw = link ? {} : ((await S.parse(val)) || {})
      claim = (raw && typeof raw === 'object') ? raw['*'] : undefined
      if(!claim){
        // Fresh client write — authenticator required; SEA.opt.pack binds sig to Gun state
        if(!link){ return no("Shard intermediate value must be link.") }
        if(link !== expected){ return no("Invalid shard link target.") }
        var sec = check.$sea(msg, user)
        var authenticator = sec.authenticator
        claim = sec.upub || ((authenticator||{}).pub)
        if(!authenticator){ return no("Shard intermediate requires authenticator.") }
        if('string' !== typeof claim || claim.length !== check.$sh.pub){ return no("Invalid shard intermediate pub.") }
        if(SEA.opt.pub('~' + claim) !== claim){ return no("Invalid shard intermediate pub format.") }
        if(0 !== claim.indexOf(prefix)){ return no("Shard pub prefix mismatch.") }
        check.auth(msg, no, authenticator, function(data){
          if(link_is(data) !== expected){ return no("Shard intermediate signed payload mismatch.") }
          msg.put[':']['*'] = claim  // append fullPub to {':':link,'~':sig} set by check.auth
          msg.put['='] = {'#': expected}
          check.next(eve, msg, no)
        })
        return
      }
      // Peer re-read: stored envelope {':': link, '~': sig, '*': fullPub}
      // Skip if local graph already has a valid link for this slot — avoid redundant verify+write
      var existing = ((at.graph||{})[soul]||{})[key]
      if(existing){
        var existingParsed = await S.parse(existing)
        if(existingParsed && link_is(existingParsed[':']) === expected){
          msg.put['='] = {'#': expected}
          return eve.to.next(msg)
        }
      }
      if('string' !== typeof claim || claim.length !== check.$sh.pub){ return no("Invalid shard intermediate pub.") }
      if(SEA.opt.pub('~' + claim) !== claim){ return no("Invalid shard intermediate pub format.") }
      if(0 !== claim.indexOf(prefix)){ return no("Shard pub prefix mismatch.") }
      if(link_is(raw[':']) !== expected){ return no("Invalid shard link target.") }
      SEA.opt.pack(msg.put, function(packed){
        SEA.verify(packed, claim, function(data){
          data = SEA.opt.unpack(data)
          if(u === data){ return no("Invalid shard intermediate signature.") }
          if(link_is(data) !== expected){ return no("Shard intermediate payload mismatch.") }
          msg.put['='] = data
          eve.to.next(msg)  // val already a JSON string — forward directly
        })
      })
    };
    check.$vfy = function(eve, msg, key, soul, pub, no, certificate, certificant, cb){
      if (!(certificate||'').m || !(certificate||'').s || !certificant || !pub) { return }
      return SEA.verify(certificate, pub, data => { // check if "pub" (of the graph owner) really issued this cert
        if (u !== data && u !== data.e && msg.put['>'] && msg.put['>'] > parseFloat(data.e)) return no("Certificate expired.") // certificate expired
        // "data.c" = a list of certificants/certified users
        // "data.w" = lex WRITE permission, in the future, there will be "data.r" which means lex READ permission
        if (u !== data && data.c && data.w && (data.c === certificant || data.c.indexOf('*') > -1 || data.c.indexOf(certificant) > -1)) {
          // ok, now "certificant" is in the "certificants" list, but is "path" allowed? Check path
          var path = soul.indexOf('/') > -1 ? soul.replace(soul.substring(0, soul.indexOf('/') + 1), '') : ''
          String.match = String.match || Gun.text.match
          var w = Array.isArray(data.w) ? data.w : typeof data.w === 'object' || typeof data.w === 'string' ? [data.w] : []
          for (const lex of w) {
            if ((String.match(path, lex['#']) && String.match(key, lex['.'])) || (!lex['.'] && String.match(path, lex['#'])) || (!lex['#'] && String.match(key, lex['.'])) || String.match((path ? path + '/' + key : key), lex['#'] || lex)) {
              // is Certificant forced to present in Path
              if (lex['+'] && lex['+'].indexOf('*') > -1 && path && path.indexOf(certificant) == -1 && key.indexOf(certificant) == -1) return no(`Path "${path}" or key "${key}" must contain string "${certificant}".`)
              // path is allowed, but is there any WRITE block? Check it out
              if (data.wb && (typeof data.wb === 'string' || ((data.wb || {})['#']))) { // "data.wb" = path to the WRITE block
                var root = eve.as.root.$.back(-1)
                if (typeof data.wb === 'string' && '~' !== data.wb.slice(0, 1)) root = root.get('~' + pub)
                return root.get(data.wb).get(certificant).once(value => { // TODO: INTENT TO DEPRECATE.
                  if (value && (value === 1 || value === true)) return no(`Certificant ${certificant} blocked.`)
                  return cb(data)
                })
              }
              return cb(data)
            }
          }
          return no("Certificate verification fail.")
        }
      })
    }
    check.next = function(eve, msg, no){
      JSON.stringifyAsync(msg.put[':'], function(err,s){
        if(err){ return no(err || "Stringify error.") }
        msg.put[':'] = s;
        return eve.to.next(msg);
      })
    }
    check.guard = function(eve, msg, key, soul, at, no, data, next){
      if(0 > key.indexOf('#')){ return next() }
      check.hash(eve, msg, data, key, soul, at, no, next)
    }
    check.auth = function(msg, no, authenticator, done){
      SEA.opt.pack(msg.put, packed => {
        if (!authenticator) return no("Missing authenticator");
        SEA.sign(packed, authenticator, async function(data) {
          if (u === data) return no(SEA.err || 'Signature fail.')
          if (!data.m || !data.s) return no('Invalid signature format')
          var parsed = SEA.opt.unpack(data.m)
          msg.put[':'] = {':': parsed, '~': data.s}
          msg.put['='] = parsed
          done(parsed)
        }, {raw: 1})
      })
    }
    check.$tag = async function(msg, cert, upub, verify, next){
      const _cert = await S.parse(cert)
      if (_cert && _cert.m && _cert.s) verify(_cert, upub, _ => {
        msg.put[':']['+'] = _cert // '+' is a certificate
        msg.put[':']['*'] = upub // '*' is pub of the user who puts
        next()
        return
      })
    }
    check.pass = function(eve, msg, raw, data, verify){
      if (raw['+'] && raw['+']['m'] && raw['+']['s'] && raw['*']){
        return verify(raw['+'], raw['*'], _ => {
          msg.put['='] = data;
          return eve.to.next(msg);
        })
      }
      msg.put['='] = data;
      return eve.to.next(msg);
    }
    check.pub = async function(eve, msg, val, key, soul, at, no, user, pub, conf){ var tmp // Example: {_:#~asdf, hello:'world'~fdsa}}
      conf = conf || {}
      const verify = (certificate, certificant, cb) => check.$vfy(eve, msg, key, soul, pub, no, certificate, certificant, cb)
      const $next = () => check.next(eve, msg, no)

      // Localize auth options into message-private SEA context.
      const sec = check.$sea(msg, user, pub)
      const opt = sec.opt
      const authenticator = sec.authenticator
      const upub = sec.upub
      const cert = conf.nocert ? u : opt.cert;
      const $expect = function(data){
        if(u === conf.want){ return 1 }
        if(data === conf.want){ return 1 }
        no(conf.err || "Unexpected payload.")
      }
      const raw = await S.parse(val) || {}
      const $hash = function(data, next){
        check.guard(eve, msg, key, soul, at, no, data, next)
      }
      const $sign = async function(){
        // if writing to own graph, just allow it
        if (pub === upub) {
          if (tmp = link_is(val)) (at.sea.own[tmp] = at.sea.own[tmp] || {})[pub] = 1
          $next()
          return
        }

        // if writing to other's graph, check if cert exists then try to inject cert into put, also inject self pub so that everyone can verify the put
        if (pub !== upub && cert) {
          return check.$tag(msg, cert, upub, verify, $next)
        }
      }
      const $pass = function(data){
        return check.pass(eve, msg, raw, data, verify)
      }

      if ('pub' === key && '~' + pub === soul) {
        if (val === pub) return eve.to.next(msg) // the account MUST match `pub` property that equals the ID of the public key.
        return no("Account not same!")
      }

      if ((user.is || authenticator) && upub && !raw['*'] && !raw['+'] && (pub === upub || (pub !== upub && cert))){
        check.auth(msg, no, authenticator, function(data){
          if(!$expect(data)){ return }
          $hash(data, $sign)
        })
        return;
      }

      SEA.opt.pack(msg.put, packed => {
        SEA.verify(packed, raw['*'] || pub, function(data){ var tmp;
          data = SEA.opt.unpack(data);
          if (u === data) return no("Unverified data.") // make sure the signature matches the account it claims to be on. // reject any updates that are signed with a mismatched account.
          if(!$expect(data)){ return }
          if ((tmp = link_is(data)) && pub === SEA.opt.pub(tmp)) (at.sea.own[tmp] = at.sea.own[tmp] || {})[pub] = 1

          $hash(data, function(){ $pass(data) })
        });
      })
      return
    };
    check.any = function(eve, msg, val, key, soul, at, no, user){ var tmp, pub;
      if(at.opt.secure){ return no("Soul missing public key at '" + key + "'.") }
      // TODO: Ask community if should auto-sign non user-graph data.
      at.on('secure', function(msg){ this.off();
        if(!at.opt.secure){ return eve.to.next(msg) }
        no("Data cannot be changed.");
      }).on.on('secure', msg);
      return;
    }

    var valid = Gun.valid, link_is = function(d,l){ return 'string' == typeof (l = valid(d)) && l }, state_ify = (Gun.state||'').ify;

    var pubcut = /[^\w_-]/; // kept for old-format parsing below
    SEA.opt.pub = function(s){
      if(!s){ return }
      s = s.split('~')[1]
      if(!s){ return }
      if('@' === (s[0]||'')[0]){ return }
      // New format: 88 alphanumeric chars (base62)
      if(/^[A-Za-z0-9]{88}/.test(s)){ return s.slice(0, 88) }
      // Old format: x.y (base64url, 87 chars) — backward compat for check.pub routing
      var parts = s.split(pubcut).slice(0,2)
      if(!parts || 2 !== parts.length){ return }
      return parts.slice(0,2).join('.')
    }
    SEA.opt.stringy = function(t){
      // TODO: encrypt etc. need to check string primitive. Make as breaking change.
    }
    SEA.opt.pack = function(d,cb,k, n,s){ var tmp, f; // pack for verifying
      if(SEA.opt.check(d)){ return cb(d) }
      if(d && d['#'] && d['.'] && d['>']){ tmp = d[':']; f = 1 }
      JSON.parseAsync(f? tmp : d, function(err, meta){
        var sig = ((u !== (meta||'')[':']) && (meta||'')['~']); // or just ~ check?
        if(!sig){ cb(d); return }
        cb({m: {'#':s||d['#'],'.':k||d['.'],':':(meta||'')[':'],'>':d['>']||Gun.state.is(n, k)}, s: sig});
      });
    }
    var O = SEA.opt;
    SEA.opt.unpack = function(d, k, n){ var tmp;
      if(u === d){ return }
      if(d && (u !== (tmp = d[':']))){ return tmp }
      k = k || O.fall_key; if(!n && O.fall_val){ n = {}; n[k] = O.fall_val }
      if(!k || !n){ return }
      if(d === n[k]){ return d }
      if(!SEA.opt.check(n[k])){ return d }
      var soul = (n && n._ && n._['#']) || O.fall_soul, s = Gun.state.is(n, k) || O.fall_state;
      if(d && 4 === d.length && soul === d[0] && k === d[1] && fl(s) === fl(d[3])){
        return d[2];
      }
      if(s < SEA.opt.shuffle_attack){
        return d;
      }
    }
    SEA.opt.shuffle_attack = 1546329600000; // Jan 1, 2019
    var fl = Math.floor; // TODO: Still need to fix inconsistent state issue.
    // TODO: Potential bug? If pub/priv key starts with `-`? IDK how possible.
  })(USE, './index');

}());